
import apiClient from '../../api/apiClient';
import { API_ENDPOINTS_ITEMS, PAGE_LIMIT, API_FIELDS_PARTICIPATES_IN } from '../../utils/constants/api_constants';
import CsvUpload from '../models/CsvUploadModel';
import Section from '../models/SectionModel';
import Competition from '../models/CompetitionModel';
import ParticipatesIn from '../models/ParticipatesInModel';
import Competitor from '../models/CompetitorModel';

import Mapper from '../models/mapper/Mappers';
import Params from '../models/params/FilterParams';
import FieldParams from '../models/params/FieldParams';
import { convertDateinAuFormat } from '../../utils/dateUtils';
import logger from '../../utils/Logger';

import SectionRepository from './SectionRepository';
import CompetitorRepository from './CompetitorRepository';
import CompetitionRepository from './CompetitionRepository';
import ParticipatesInRepository from './ParticipatesInRepository';



class CsvUploaderRepository {

    getCsvModelListFromPapaParse(papaParseData) {

        const mappedData = papaParseData.map(
            (item) => Mapper.mapPapaParseCsvToCsvModel(item)
        );
        return mappedData
    }

    async uploadCSVDataToApi(papaParseData, onProgressUpdate) {
        const sectionRepository = new SectionRepository();
        const competitorRepository = new CompetitorRepository();
        const competitionRepository = new CompetitionRepository();
        const participatesInRepository = new ParticipatesInRepository();



        const csvModelList = this.getCsvModelListFromPapaParse(papaParseData)
        console.log("Csvmodel List is: ", csvModelList.length)

        logger.addInformation(`Total CSV model(after mapped) list to upload is ${csvModelList.length}`);

        for (let i = 0; i < csvModelList.length; i++) {
            const csvModel = csvModelList[i]
            // const competitionDate = convertAuDateIntoApiDate(csvModel.competitionDate)
            const competitionDate = csvModel.competitionDate


            if (!competitionDate) {
                const errorMessage = `Error: Competition date is undefined at row ${i + 1}.`;
                logger.addError(errorMessage);
                throw new Error(errorMessage);
            }

            console.log("Csvmodel: ", csvModel)
            logger.addInformation(`------------------------------------------Row Break---------------------------------------------------------------`)

            logger.addInformation(`Processing row ${i + 1}: Section Code = ${csvModel.sectionCode}, Competitor Name = ${csvModel.competitorsName}, Email: ${csvModel.competitorEmailAddress}, Competition Date: ${competitionDate}`);

            const sectionModel = await sectionRepository.createSectionWithSectionExistsCheck(new Section(null, csvModel.sectionCode, csvModel.sectionDescription))
            console.log("Section Model After Upload is: ", sectionModel)
            logger.addInformation(`Row ${i + 1}: Section created or fetched. Section ID = ${sectionModel.sectionId}`);

            const competitorModel = await competitorRepository.createCompetitorWithCompetitorExistsCheck(new Competitor(null, csvModel.competitorsName, csvModel.competitorEmailAddress))
            console.log("Competitor Model After Upload is: ", competitorModel)
            logger.addInformation(`Row ${i + 1}: Competitor created or fetched. Competitor ID = ${competitorModel.competitorId}`);


            const competitionModel = await competitionRepository.createCompetitionWithCompetitionExistsCheck(new Competition(null, null, null, competitionDate, sectionModel.sectionId))
            console.log("Competition Model After Upload is: ", competitionModel)
            logger.addInformation(`Row ${i + 1}: Competition created or fetched. Competition ID = ${competitionModel.competitionId}`);


            const participatesInModel = await participatesInRepository.createParticipatesWithCompetitionAndCompetitorExistsCheck(new ParticipatesIn(null, null, csvModel.competitorOrderNo, competitorModel.competitorId, competitionModel.competitionId))
            console.log("Participates In Model After Upload is: ", participatesInModel)
            logger.addInformation(`Row ${i + 1}: Participation record created or fetched. Participation ID = ${participatesInModel.participatesInId}`);


            onProgressUpdate(i + 1, csvModelList.length);

            // break

        }




    }








}

export default CsvUploaderRepository;
